import { Box, NumberField } from '@iheartjane/reefer';
import { useState } from 'react';

import {
  SlidingBackground,
  Tip,
  TipContainer,
  TransitionedTypography,
} from './tippingInput.styles';

interface TippingInputProps {
  cartTotal: number;
  currentTipAmount: number;
  isPercentage: boolean;
  onTipChange: (tip: number) => void;
  tipOptions: Array<{ label: string; value: number | string }>;
}

export const TippingInput = ({
  tipOptions,
  isPercentage,
  cartTotal,
  currentTipAmount,
  onTipChange,
}: TippingInputProps) => {
  const [selectedTip, setSelectedTip] = useState<number | string>(0);

  const handleTipChange = (value: number | string) => {
    if (value === selectedTip) {
      setSelectedTip(0);
      onTipChange(0);
      return;
    }

    setSelectedTip(value);

    if (value !== 'custom' && typeof value === 'number') {
      const tip = isPercentage ? cartTotal * value : value;
      onTipChange(parseFloat(tip.toFixed(2)));
    }
  };

  const handleCustomTipChange = (value: number) => {
    onTipChange(value);
  };

  return (
    <Box mt={24}>
      <TipContainer>
        <SlidingBackground
          length={tipOptions.length}
          index={tipOptions.findIndex(
            (element) => element.value === selectedTip
          )}
        />

        {tipOptions.map((option, i) => (
          <Tip
            key={`${option.value}-${i}`}
            onClick={() => handleTipChange(option.value)}
          >
            <TransitionedTypography
              textAlign="center"
              variant="body-bold"
              color={
                selectedTip === option.value ? 'grays-white' : 'grays-black'
              }
            >
              {option.label}
            </TransitionedTypography>
          </Tip>
        ))}
      </TipContainer>

      {selectedTip === 'custom' && (
        <NumberField
          allowedDecimalPlaces={2}
          disableMobileInputStyling
          defaultValue={currentTipAmount}
          label=""
          name="custom-tip"
          onChange={handleCustomTipChange}
          startUnit="$"
        />
      )}
    </Box>
  );
};
